import React, { createContext, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import QMentisBreadCrumb from "../custom-components/QMentisBreadCrumb";

export const TestPlanContext = createContext(null);
export const TestPlanLoaderStateContext = createContext(null);


const TestPlanPage = () => {
  const [testPlanIdentifier, setTestPlanIdentifier] = useState({});
  const [testPlanTypes, setTestPlanTypes] = useState({});
  const [testPlanEnvironment, setTestPlanEnvironment] = useState({});
  const [testPlanOutput, setTestPlanOutput] = useState({});

  const breadCrumbs = [
    {
      title: "Test Plan Identifier",
      status:
        Object.keys(testPlanIdentifier).length > 0 ? "Completed" : "In Progress",
    },
    {
      title: "Types of Testing",
      status:
        Object.keys(testPlanTypes || {}).length > 0
          ? "Completed"
          : Object.keys(testPlanIdentifier || {}).length > 0
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Test Environment",
      status:
        Object.keys(testPlanEnvironment || {}).length > 0
          ? "Completed"
          : Object.keys(testPlanTypes || {}).length > 0
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Generated Test Plan",
      status:
        Object.keys(testPlanOutput || {} ).length > 0
          ? "Completed"
          : Object.keys(testPlanEnvironment || {}).length > 0
          ? "In Progress"
          : "Not Started",
    },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* BreadCrumb section */}
        <Box
          sx={{
            position: "fixed", // Fix it at the desired position
            // top: 0, // Adjust this if needed
            width: "100%",
            zIndex: 1000, // Make sure it's above other content
            bgcolor: "white", // Add a background color to prevent overlap issues
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional: Add shadow for separation
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{ height: "56px", ml: -10 }}
          />
        </Box>

        {/* Main content section */}
        <Box
          sx={{
            paddingTop: "60px", // Add padding equivalent to the height of the fixed BreadCrumb
          }}
        >
          <TestPlanContext.Provider
            value={{
              setTestPlanIdentifier,
              testPlanIdentifier,
              setTestPlanTypes,
              testPlanTypes,
              setTestPlanEnvironment,
              testPlanEnvironment,
              setTestPlanOutput,
              testPlanOutput,
            }}
          >
            <Outlet />
          </TestPlanContext.Provider>
        </Box>
      </Box>
    </Box>
  );
};

export default TestPlanPage;
